import { Menu } from 'lucide-react'

export function PageHeader({
  title,
  subtitle,
  onMenu,
  showMenu,
  right,
}: {
  title: string
  subtitle?: string
  onMenu: () => void
  showMenu: boolean
  right?: React.ReactNode
}) {
  return (
    <header className="flex items-center gap-2 h-16 px-4 md:px-6 border-b border-border shrink-0 bg-card">
      {showMenu && (
        <button onClick={onMenu} className="p-2 -ml-2 rounded-md hover:bg-muted" aria-label="Menu">
          <Menu className="size-5 text-foreground" />
        </button>
      )}
      <div className="flex-1 min-w-0 leading-tight">
        <h1 className="text-base font-semibold text-foreground truncate">{title}</h1>
        {subtitle && <p className="text-[11px] text-muted-foreground truncate">{subtitle}</p>}
      </div>
      {right}
    </header>
  )
}
